export class GetCUPPermanentListInput{
    EduNo: string = '';
    DeptNo: string = '';
    Status: string = '';
    SelKind: string = '';
    KeyWord: string = '';
    OrderBy: string = '1';
    FiledsNo: string = '';
    Selected: boolean = false;
}